import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { Box, Button, Card, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { handleError } from '../../../shared/functions/handleError';
import { usePagination } from '../../../shared/hooks/usePagination';
import { ILeaveDay } from '../../../shared/interfaces/leave-days/ILeaveDay';
import { LeaveDaysTable } from './components/LeaveDaysTable';
import { AdminLeaveDaysService } from './service';

const AdminLeaveDays = () => {
  const { t } = useTranslation();
  const [data, setData] = useState<ILeaveDay[] | undefined>(undefined);
  const [selectedLeaveDay, setSelectedLeaveDay] = useState<ILeaveDay | null>(
    null,
  );
  const [isAddModalOpened, setIsAddModalOpened] = useState(false);

  const {
    changeFilterHandler,
    pagination,
    setCount,
    totalPages,
    setTotalPages,
    count,
    setPagination,
    handleUpdateList,
  } = usePagination({
    perPage: 15,
  });

  useEffect(() => {
    AdminLeaveDaysService.get({ ...pagination, page: pagination?.page + 1 })
      .then((response) => {
        setCount(response?.count);
        setTotalPages(Math.ceil(response?.count / pagination?.perPage));
        setData(response.data);
      })
      .catch(handleError);
  }, [pagination, setTotalPages, setCount]);

  return (
    <>
      <Card>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingBottom: '20px',
          }}
        >
          <TextField
            onChange={(e) => {
              changeFilterHandler('name', e.target.value);
            }}
            label={t('general.searchByName')}
            sx={{
              width: { xs: '100%', md: 'auto' },
              paddingBottom: { xs: 2, md: 0 },
            }}
          />

          <Button
            variant={'contained'}
            onClick={() => {
              setSelectedLeaveDay(null);
              setIsAddModalOpened(true);
            }}
            sx={{ width: { xs: '100%', md: 'auto' } }}
          >
            <AddCircleOutlineOutlinedIcon sx={{ marginRight: '5px' }} />
            {t('button.addNewLeave')}
          </Button>
        </Box>
        <LeaveDaysTable
          data={data}
          totalPages={totalPages}
          pagination={pagination}
          setPagination={setPagination}
          handleUpdateList={handleUpdateList}
          isAddModalOpened={isAddModalOpened}
          setIsAddModalOpened={setIsAddModalOpened}
          count={count}
          selectedLeaveDay={selectedLeaveDay}
          setSelectedLeaveDay={setSelectedLeaveDay}
        />
      </Card>
    </>
  );
};

export default AdminLeaveDays;
